// Mock data para LUCARS website

export const siteInfo = {
  name: "LUCARS",
  tagline: "SIEMPRE EN MOVIMIENTO",
  phone: "+52 999 654 0317",
  email: "contacto@lucars.com.mx",
  instagram: "lucarsmid2021",
  instagramUrl: "https://instagram.com/lucarsmid2021"
};

export const heroData = {
  title: "LUCARS",
  subtitle: "SIEMPRE EN MOVIMIENTO",
  description: "Estrena Auto Nuevo y Genera Ingresos a través de Plataformas Tecnológicas.",
  image: "https://images.unsplash.com/photo-1519608487953-e999c86e7455",
  cta: "Conocer más"
};

export const aboutData = {
  title: "¿Quiénes Somos?",
  description: "Somos una empresa mexicana con operaciones en la Península de Yucatán, enfocada en brindar soluciones de movilidad que impulsan el crecimiento personal y la generación de ingresos.",
  description2: "A través de autos a gasolina y eléctricos, y en colaboración con plataformas tecnológicas, ayudamos a que más personas estrenen un auto nuevo mientras construyen un futuro financiero más estable.",
  description3: "En Lucars, creemos que la movilidad no solo conecta destinos, sino que abre oportunidades, genera independencia y transforma vidas.",
  valueProposition: "Nuestros clientes generan sus propios ingresos sin preocuparse por los gastos adicionales que implica un automóvil. Al término del plazo estipulado en el contrato, tienen la posibilidad de adquirir su propio auto, consolidando así su esfuerzo y construyendo patrimonio.",
  image: "https://images.unsplash.com/photo-1712193424561-d1e2c09f524e",
  image2: "https://images.unsplash.com/photo-1567409378873-888d6fa7debc",
  stats: [
    { number: "2021", label: "Año de Fundación" },
    { number: "UBER, DIDI & InDriver", label: "Alianzas Estratégicas" },
    { number: "Yucatán", label: "Península de Yucatán" },
    { number: "Campeche", label: "Próximamente" }
  ]
};

export const howWeDoItData = {
  title: "¿Cómo lo Hacemos?",
  description: "Nuestro proceso se basa en 5 puntos",
  backgroundImage: "https://images.unsplash.com/photo-1535391879778-3bae11d29a24",
  steps: [
    {
      number: "1",
      title: "Revisamos tus Documentos",
      description: "Analizamos tu información y documentación para iniciar el proceso.",
      icon: "ClipboardCheck"
    },
    {
      number: "2",
      title: "Escoge tu Nuevo Auto",
      description: "Selecciona el vehículo que mejor se adapte a tus necesidades.",
      icon: "Car"
    },
    {
      number: "3",
      title: "Preparamos Documentación",
      description: "Nos encargamos de toda la gestión legal y administrativa.",
      icon: "FileText"
    },
    {
      number: "4",
      title: "Estrena y Genera Ingresos",
      description: "Comienza a trabajar y generar tus propios ingresos desde el día uno.",
      icon: "TrendingUp"
    },
    {
      number: "5",
      title: "Adquiere tu Auto",
      description: "Al finalizar el contrato, el vehículo puede ser tuyo.",
      icon: "Key"
    }
  ]
};

export const whyChooseUsData = {
  title: "¿Por Qué Elegirnos?",
  description: "Queremos ser parte de tu historia.\n\nSabemos lo difícil que es generar ingresos por cuenta propia, por eso apoyamos otorgando una herramienta de trabajo que te permita hacerlo de forma adecuada, brindando soluciones de movilidad que, al mismo tiempo, ayudan a que más personas disfruten viajes cómodos, seguros y, en algunos casos, más amigables con el medio ambiente.\n\nEn Lucars nos enfocamos en cada persona. Nos gusta conocer la historia de cada uno de nuestros clientes, porque no queremos ser solo una opción más; queremos convertirnos en una pequeña parte de su éxito.\n\nEn esta ocasión, tú marcas el camino.\nNosotros te brindamos la solución.\nLo demás corre por tu cuenta.\n\n\"Si trabajas en lo que te gusta, no trabajarás ni un día.\"",
  benefits: [
    {
      title: "Generación de Ingresos",
      description: "Los conductores generan sus propios ingresos con flexibilidad horaria.",
      icon: "TrendingUp"
    },
    {
      title: "Opción de Compra",
      description: "Al término del contrato, puedes adquirir tu automóvil.",
      icon: "Car"
    },
    {
      title: "Cero Emisiones",
      description: "Vehículos eléctricos que no contaminan el medio ambiente.",
      icon: "Leaf"
    },
    {
      title: "Bajo Costo Operativo",
      description: "$0.25 - $0.30 MXN por km vs $1.00 - $3.00 en gasolina.",
      icon: "Zap"
    },
    {
      title: "Mantenimiento Mínimo",
      description: "Menos piezas, menos problemas. Mantenimiento cada 20,000 km.",
      icon: "Wrench"
    },
    {
      title: "Seguridad 24/7",
      description: "Monitoreo GPS constante y seguros completos.",
      icon: "Lock"
    }
  ],
  comparison: {
    title: "Eléctricos vs Gasolina",
    electric: {
      costPerKm: "$0.25 - $0.30 MXN",
      maintenance: "Mínimo, cada 20,000 km",
      lifespan: "500,000+ km",
      emissions: "0 emisiones",
      charging: "1-5 horas",
      range: "300-380 km"
    },
    gasoline: {
      costPerKm: "$1.00 - $3.00 MXN",
      maintenance: "Cambios regulares",
      lifespan: "200,000-300,000 km",
      emissions: "CO2 y contaminantes",
      charging: "5 minutos",
      range: "500-600 km"
    }
  },
  riskMitigation: [
    "Operaciones en Yucatán, uno de los estados más seguros de México",
    "Seguro con cobertura amplia, reembolso del 90%",
    "Mantenimientos preventivos y correctivos exclusivos",
    "Todos los automóviles se venden al finalizar el plazo convenido"
  ]
};

export const contactData = {
  title: "Contacto",
  description: "¿Listo para generar ingresos con LUCARS? Contáctanos y comienza tu camino hacia la independencia financiera.",
  phone: "+52 999 654 0317",
  email: "contacto@lucars.com.mx",
  instagram: "lucarsmid2021",
  address: "Mérida, Yucatán, México"
};

export const vehicleGallery = {
  electric: [
    "https://images.unsplash.com/photo-1712193424561-d1e2c09f524e",
    "https://images.unsplash.com/photo-1671785120538-c24cbe823ccc",
    "https://images.pexels.com/photos/27243718/pexels-photo-27243718.jpeg"
  ],
  gasoline: [
    "https://images.unsplash.com/photo-1504366130991-154787072d46",
    "https://images.unsplash.com/photo-1598889933677-e433366327f6",
    "https://images.unsplash.com/photo-1616932321030-16411c3a6489"
  ]
};